import script from "./Email.vue?vue&type=script&setup=true&lang=ts"
export * from "./Email.vue?vue&type=script&setup=true&lang=ts"

import "./Email.vue?vue&type=style&index=0&id=025a890c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-025a890c"]])